import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackRemoveReminderFromWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackRemoveReminderFromWishList = (
    parameters: TrackRemoveReminderFromWishListParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "remove_reminder_from_wishlist", ...parameters }, options);
};

export default trackRemoveReminderFromWishList;
